import { useState, useEffect } from "react";
import axios from "axios";
import { Alert, Modal, Table, Col, Row, Form, Button } from "react-bootstrap";
import SearchableDropdown from "../SearchableDropdown";
import { times, buildDisplayName } from "../Utils";

// https://blog.devgenius.io/react-bootstrap-creating-controlled-forms-to-add-and-update-data-with-a-flexible-number-of-inputs-6d2e4e6977c7

const ModalCrud = (props) => {
  const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";
  const ls = require("localstorage-ttl");

  const [isLoading, setLoading] = useState(false);
  const [isSearchingUser, setSearchingUser] = useState(false);
  const [instructorResult, setInstructorResult] = useState([]);
  const [studentResult, setStudentResult] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");

  const [id, setId] = useState();
  const [day, setDay] = useState();
  const [time, setTime] = useState(times[0]);
  const [instructor, setInstructor] = useState(null);
  const [guests, setGuests] = useState();
  const [students, setStudents] = useState([]);

  const dojo = props.dojodetail;
  const dojoClass = props.dojoclass;

  const usuario = JSON.parse(ls.get("userData"));
  const token = JSON.parse(ls.get("jwt"));

  useEffect(() => {
    console.log({ dojoClass });
    console.log({ dojo });
    if (dojoClass) {
      setId(dojoClass.id);
      setDay(dojoClass.attributes.day);
      setGuests(dojoClass.attributes.guests);
      const hora = times.filter((t) => t.id == dojoClass.attributes.time);
      setTime(hora[0]?.value);
      setInstructor({
        id: dojoClass.attributes.instructor.data.id,
        value: buildDisplayName(
          dojoClass.attributes.instructor.data.attributes
        ),
      });
      const alumnos = dojoClass.attributes.alumnos?.data.map((a) => {
        return {
          id: a.id,
          value: buildDisplayName(a.attributes),
        };
      });
      setStudents(alumnos);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function removeStudent(s) {
    if (s != null) setStudents(students.filter((e) => e.id !== s.id));
  }

  function addStudent(s) {
    if (s != null) setStudents(students.concat(s));
  }

  function isIncomplete() {
    console.log({ instructor });
    return (
      !day ||
      day === "" ||
      !time ||
      time === "" ||
      !instructor ||
      instructor === ""
    );
  }

  const headerRequest = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  async function getUserByAny(value, destination) {
    // setDocNumber(docNumber);
    if (value && value.length > 3) {
      setSearchingUser(true);
      setErrorMessage(null);

      await axios
        .get(
          `${API_URL}/users/?filters[$or][0][docNumber][$startsWithi]=${value}&filters[$or][1][name][$startsWithi]=${value}&filters[$or][2][lastname][$startsWithi]=${value}`,
          headerRequest
        )
        .then((res) => {
          if (res.data) {
            //setInstructor(userData.instructor);
            const data = res.data.map(function (i) {
              return {
                id: i.id,
                value: buildDisplayName(i),
              };
            });
            destination == "instructor"
              ? setInstructorResult(data)
              : setStudentResult(data);
          }
        })
        .catch((error) => {
          console.log("Error find student:", error);
        })
        .finally(() => {
          setSearchingUser(false);
        });
      console.log({ instructorResult });
    }
  }

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();

    const alumnos = students.map((i) => {
      return i.id;
    });

    let reqClass = {
      data: {
        day,
        time: time + ":00.000",
        dojo: dojo.id,
        instructor: instructor.id,
        guests,
        alumnos,
      },
    };
    console.log({ reqClass });
    if (!id) {
      await axios
        .post(`${API_URL}/classes`, reqClass, headerRequest)
        .then((u) => {
          setLoading(false);
          props.onHide(true);
        })
        .catch((error) => {
          setLoading(false);
          console.log("Error with post classes:", error.response);
          setErrorMessage(
            "Hubo un error, intente nuevamente. " +
              error.response.data.error.message
          );
          return;
        });
    } else {
      await axios
        .put(`${API_URL}/classes/${id}`, reqClass, headerRequest)
        .then((u) => {
          setLoading(false);
          props.onHide(true);
        })
        .catch((error) => {
          setLoading(false);
          console.log("Error with put classes:", error.response);
          setErrorMessage(
            "Hubo un error, intente nuevamente. " +
              error.response.data.error.message
          );
          return;
        });
    }
  };

  return (
    <Modal
      {...props}
      backdrop="static"
      aria-labelledby="contained-modal-title-vcenter"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {dojoClass ? "Editar" : "Crear"} Clase
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="show-grid">
        <Form onSubmit={(e) => handleSubmit(e)}>
          <Row className="mb-3">
            <Form.Group as={Col} controlId="formDay">
              <Form.Label>Día</Form.Label>
              <Form.Control
                type="date"
                name="day"
                min="2023-09-01"
                max="2050-12-31"
                value={day}
                onChange={(e) => setDay(e.target.value)}
              />
            </Form.Group>

            <Form.Group as={Col} controlId="formTime">
              <Form.Label>Hora</Form.Label>
              <Form.Select
                value={time}
                onChange={(e) => setTime(e.target.value)}
              >
                {times.map((i) => {
                  return (
                    <option key={i.id} value={i.value}>
                      {i.value}
                    </option>
                  );
                })}
              </Form.Select>
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group
              as={Col}
              controlId="formDocNumber"
              className="has-feedback"
            >
              <Form.Label>Instructor</Form.Label>
              <SearchableDropdown
                options={instructorResult}
                label="value"
                id="id"
                selectedVal={instructor?.value}
                onChange={(e) => getUserByAny(e, "instructor")}
                handleChange={(e) => setInstructor(e)}
              />
              {isSearchingUser ? (
                <span className="loading form-control-feedback"></span>
              ) : null}
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group
              as={Col}
              controlId="formDocNumber"
              className="has-feedback"
            >
              <h5>Alumnos</h5>
              <span class="mini">Buscar</span>

              <SearchableDropdown
                options={studentResult}
                label="value"
                id="id"
                onChange={(e) => getUserByAny(e, "student")}
                handleChange={(e) => addStudent(e)}
              />
              {students.length > 0 ? (
                <>
                  <br />
                  <span class="mini">Presentes</span>
                  <Table striped hover size="sm" responsive="sm">
                    <tbody>
                      {students.map((e) => (
                        <tr id={e.id} key={e.id}>
                          <td align="left">{e.value}</td>
                          <td align="right">
                            <>
                              <Button
                                size="sm"
                                onClick={() => removeStudent(e)}
                                variant="danger"
                              >
                                Borrar
                              </Button>
                            </>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </>
              ) : (
                <span class="mini">Sin alumnos</span>
              )}
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} controlId="formGuests">
              <Form.Label>Invitados</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={guests}
                onChange={(e) => setGuests(e.target.value)}
              />
            </Form.Group>
          </Row>

          <Button
            variant="primary"
            type="submit"
            disabled={isLoading || isIncomplete()}
          >
            {isLoading ? "Procesando…" : "GRABAR"}
          </Button>
          {errorMessage ? (
            <Alert className="mt-3" variant="danger">
              {errorMessage}
            </Alert>
          ) : (
            <></>
          )}
        </Form>
      </Modal.Body>
    </Modal>
  );
};
export default ModalCrud;
